// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2c-AL","info":"Note_info__p4eTA","note":"Note_note__16nXJ","actions":"Note_actions__30xx7"};